import { render, staticRenderFns } from "./AttentionTips.vue?vue&type=template&id=23cb12f0"
import script from "./AttentionTips.vue?vue&type=script&lang=js"
export * from "./AttentionTips.vue?vue&type=script&lang=js"
import style0 from "./AttentionTips.vue?vue&type=style&index=0&id=23cb12f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports